(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('showcaseFlyerCard', {
            templateUrl: 'app/admin/showcases/components/showcase-flyer-card/showcase-flyer-card.html',
            bindings: {
                flyer: '<',
                isMobile: '<?',
                isImmoContext: '<?'
            },
            controller: showcaseFlyerCardController
        });
})();

    /** @ngInject */
    function showcaseFlyerCardController($localStorage, FlyersCurrencyValue) {
        var $ctrl = this;

        $ctrl.$onInit = init;

        function init() {
            $ctrl.isImmoContext = !!$ctrl.isImmoContext;
            $ctrl.isMobile = !!$ctrl.isMobile;
            $ctrl.isHubContext = false;
            $ctrl.flyerActions = null;
            $ctrl.checkboxIsChecked = false;
            $ctrl.currencyInstance = $localStorage.defaultStore.storeInfo.currencyConfiguration;

            if ($ctrl.flyer && !$ctrl.flyer.currencyInstance && $ctrl.flyer.currency) {
                $ctrl.flyer.currencyInstance = {
                    prefix: FlyersCurrencyValue[$ctrl.flyer.currency]
                };
            }

            if ($ctrl.flyer && (!$ctrl.flyer.details || $ctrl.flyer.details.length === 0)) {
                $ctrl.flyer.details = [{
                    purchaseValue: $ctrl.flyer.purchaseValue,
                    discountedValue: $ctrl.flyer.discountedValue
                }];
            }

            $ctrl.formatedAddress = $ctrl.flyer && $ctrl.flyer.address
                ? ($ctrl.flyer.address.street + ' - ' + $ctrl.flyer.address.city + ' - ' + $ctrl.flyer.address.state)
                : "";

            $ctrl.getMinMaxPurchaseValue();
        }

        $ctrl.getMinMaxPurchaseValue = function () {
            var res = getFlyerMinMaxPurchaseValue($ctrl.flyer && $ctrl.flyer.details, $ctrl.isRealEstateMarket);
            $ctrl.hasDetails = res.hasDetails;
            $ctrl.singleItem = res.singleItem;
            $ctrl.minPurchaseValue = res.minPurchaseValue;
            $ctrl.maxPurchaseValue = res.maxPurchaseValue;
            $ctrl.shouldShowSingleValue = res.shouldShowSingleValue;
        };
    }

